<template>
  <div class="home">
    <header-component
      title="
      Dirección: Av. Aviación, 2468, segundo piso San Borja, Lima
      "
      map="true"
    />
    <info-block-component />
    <b-modal :active.sync="isComunicado" :width="640" scroll="keep">
            <div class="has-background-white message">
                <div class="container is-centered">
                  <h1 v-if="isComunicado" class="title is-3 title-message" v-html="this.comunicado.title">{{this.comunicado.title}} </h1>
                  <h2 v-if="isComunicado" class="subtitle is-5 text-message" v-html="this.comunicado.comunicado">{{this.comunicado.comunicado}} </h2>
                </div>
            </div>
        </b-modal>
  </div>
</template>

<script>
/*<img src="{{asset('img/notariaVilca.jpg')}}" />*/
import HeaderComponent from "@/components/HeaderComponent.vue";
import InfoBlockComponent from "@/components/InfoBlockComponent.vue";
export default {
  components: {
    HeaderComponent,
    InfoBlockComponent
  },
  mounted() {
    console.log("Example Component mounted.");
    this.$http
        .get(this.$store.state.url + "/api/comunicado", {}, {
          headers: {
            Authorization: "Bearer " + this.$store.state.user.token
          }
        })
        .then(response => {
          if(response.data.success){
            this.comunicado=response.data.success;
            if(this.comunicado.comunicado!=null && this.comunicado.comunicado!=""){
              this.isComunicado=true;
            }
          }
          // this.$router.push("/usuario");
          console.log(response);
        });
  },
  data() {
    return {
      imgHome: process.env.MIX_APP_URL + "img/notariaVilca.jpg",
      isComunicado:false,
      comunicado:null
    };
  }
};
</script>

<style lang="scss">

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.home{
  .message{
    padding: 20px;
    .title-message{
      text-decoration: underline;
      padding-bottom: 15px;
    }
    .text-message{
      line-height: 1.5em;
    }
  }
}
</style>
